import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import {
    Card,
    Container
} from 'reactstrap';
import EditableText from "@/components/EditableText";
import Button from "@/components/Button";
import TrophySVG from "@/public/site-assets/svg/trophy.svg";
import StationarySVG from "@/public/site-assets/svg/stationary.svg";
import BrushSVG from "@/public/site-assets/svg/green-brush.svg";
import DimensionsSVG from "@/public/site-assets/svg/dimensions.svg";
import TubeSVG from "@/public/site-assets/svg/red-tube.svg";
import StarSVG from "@/public/site-assets/svg/star.svg";
import ScissorSVG from "@/public/site-assets/svg/scissors.svg";


import { motion } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';

export default function SimpleContent({
    global,
    pathPrefix,
    className,
    content,
    lead_content,

    cta_title_1,
    cta_link_1,
    cta_class_1,

    style1
}) {

    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <section ref={sectionRef} className={clsx(className, styles.root)}>
            <Container className='position-relative'>
                {style1 && (
                    <>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 1.3 }}><TrophySVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 1 }}><StationarySVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 0.3 }}><BrushSVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 2 }}><TubeSVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 2.3 }}><StarSVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 3 }}><ScissorSVG /></motion.span>
                        <motion.span className='floating-icon' initial={{ opacity: 0 }} animate={isVisible ? { opacity: 1 } : {}} transition={{ duration: 1.5, delay: 3.3 }}><DimensionsSVG /></motion.span>
                    </>
                )}
                <div className='wrapper position-relative'>
                    {lead_content && (
                        <EditableText
                            content={lead_content}
                            path={`${pathPrefix}.lead_content`}
                            global={global}
                            tag={`div`}
                            className={`lead-content`}
                            html={true}
                        />
                    )}
                    {content && (
                        <EditableText
                            content={content}
                            path={`${pathPrefix}.content`}
                            global={global}
                            tag={`div`}
                            className={`content`}
                            html={true}
                        />
                    )}
                    {cta_link_1 && (
                        <div className={`d-flex justify-content-center`}>
                            <Button
                                text={`${cta_title_1}`}
                                url={`${cta_link_1}`}
                                className={`m-0 mt-2 ${cta_class_1}`}
                            />
                        </div>
                    )}
                </div>
            </Container>
        </section>
    )
}

SimpleContent.defaultProps = {
    className: "",
};

SimpleContent.propTypes = {
    className: PropTypes.string,
};